<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 50vw">
      <div class="modal-header">
        <h5 class="modal-title">Patient Profile</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="isLoaded" class="modal-body">
        <!-- Patient Details Section -->
        <div class="section-card">
          <h6 class="section-title">Patient Information</h6>
          <div class="profile-header">
            <img
              v-if="parseInt(patient_data.gender, 10) == 1"
              src="../../../assets/img/icons/flags/male.png"
              alt="Patient Photo"
            />
            <img
              v-if="parseInt(patient_data.gender, 10) == 2"
              src="../../../assets/img/icons/flags/female.png"
              alt="Patient Photo"
            />
            <img
              v-if="
                parseInt(patient_data.gender, 10) != 1 &&
                parseInt(patient_data.gender, 10) != 2
              "
              src="../../../assets/img/icons/flags/nogender.png"
              alt="Patient Photo"
            />
            <div>
              <h2>{{ patient_data.name }}</h2>
              <p>
                National ID / Passport No
                <span style="color: black">: {{ patient_data.id_number }}</span>
              </p>
              <span
                >Gender:
                {{
                  patient_data.gender == null
                    ? "-"
                    : patient_data.gender == "1"
                    ? "Male"
                    : patient_data.gender == "2"
                    ? "Female"
                    : "Other"
                }}</span
              >
            </div>
          </div>
          <div class="profile-details">
            <div class="detail">
              <table class="table table-bordered">
                <tr>
                  <th>Date of Birth:</th>
                  <th>AGE:</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ patient_data.dob }}</span>
                  </td>
                  <td>
                    <span>{{ age }}</span>
                  </td>
                </tr>
              </table>
            </div>

            <div class="detail">
              <label>Contacts:</label>
              <table class="table table-bordered">
                <tr>
                  <th>Phone:</th>
                  <th>Email:</th>
                </tr>
                <tr>
                  <td>
                    <span>{{ patient_data.phone }}</span>
                  </td>
                  <td>
                    <span>{{
                      patient_data.email == null ? "null" : patient_data.email
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
            <div class="detail">
              <label>Address:</label>
              <span>{{ patient_data.location }}</span>
            </div>
            <div class="detail">
              <label>Medical Notes:</label>
              <span>{{ "n/a" }}</span>
            </div>
          </div>
        </div>

        <!-- Next of Kin Section -->
        <div class="section-card" v-if="hasNextOfKin">
          <h6 class="section-title">Next of Kin Details</h6>
          <div class="next-of-kin-section">
            <div class="kin-profile-header">
              <img
                v-if="parseInt(next_of_kin.gender, 10) == 1"
                src="../../../assets/img/icons/flags/male.png"
                alt="Next of Kin Photo"
                class="kin-avatar"
              />
              <img
                v-if="parseInt(next_of_kin.gender, 10) == 2"
                src="../../../assets/img/icons/flags/female.png"
                alt="Next of Kin Photo"
                class="kin-avatar"
              />
              <!-- <img
                v-if="
                  parseInt(next_of_kin.gender, 10) != 1 &&
                  parseInt(next_of_kin.gender, 10) != 2
                "
                src="../../../assets/img/icons/flags/nogender.png"
                alt="Next of Kin Photo"
                class="kin-avatar"
              /> -->
              <div>
                <h3>{{ next_of_kin.name || "N/A" }}</h3>
                <p class="kin-relationship">
                  Relationship:
                  <span class="kin-relation-value">{{
                    patient_data.nok_relationship || "N/A"
                  }}</span>
                </p>
              </div>
            </div>

            <div class="kin-details-grid">
              <div class="kin-detail-item">
                <label>Contact Phone:</label>
                <span class="kin-value">{{ next_of_kin.phone || "N/A" }}</span>
              </div>

              <div class="kin-detail-item">
                <label>Email Address:</label>
                <span class="kin-value">{{ next_of_kin.email || "N/A" }}</span>
              </div>

              <div class="kin-detail-item full-width">
                <label>Residential Address:</label>
                <span class="kin-value">{{
                  next_of_kin.location || "N/A"
                }}</span>
              </div>

              <!-- <div class="kin-detail-item">
                <label>Emergency Contact:</label>
                <span class="kin-value">
                  {{ next_of_kin.is_emergency_contact ? "Yes" : "No" }}
                </span>
              </div> -->

              <div class="kin-detail-item">
                <label>ID Number:</label>
                <span class="kin-value">{{
                  next_of_kin.id_number || "N/A"
                }}</span>
              </div>
            </div>

            <!-- Additional Information if available -->
            <div v-if="next_of_kin.additional_info" class="kin-notes">
              <label>Additional Information:</label>
              <div class="kin-notes-content">
                {{ next_of_kin.additional_info }}
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State for Next of Kin -->
        <div class="section-card" v-else>
          <h6 class="section-title">Next of Kin Details</h6>
          <div class="empty-state">
            <div class="empty-state-icon">👤</div>
            <p>No next of kin information available</p>
          </div>
        </div>
      </div>

      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          align-self: center;
          color: black;
          font-weight: bold;
        "
        v-if="!isLoaded"
      >
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";

export default {
  name: "ModalContent",
  data() {
    return {
      patient_data: {},
      next_of_kin: {},
      isLoaded: false,
    };
  },

  computed: {
    age() {
      if (!this.patient_data.dob) {
        return "N/A";
      }

      const today = new Date();
      const birthDate = new Date(this.patient_data.dob);

      let ageInYears = today.getFullYear() - birthDate.getFullYear();
      let ageInMonths = today.getMonth() - birthDate.getMonth();

      if (ageInMonths < 0) {
        ageInYears--;
        ageInMonths += 12;
      }

      return `${ageInYears} years and ${ageInMonths} months`;
    },

    hasNextOfKin() {
      return (
        this.next_of_kin &&
        Object.keys(this.next_of_kin).length > 0 &&
        this.next_of_kin.name
      );
    },
  },

  props: {
    patient_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save");
    },

    async call_api() {
      this.isLoaded = false;
      const url = "getUserById";
      const body = {
        user_id: this.patient_id,
      };
      const res = await generalApiRequest(url, "POST", body, 1);
      console.log(res);
      this.patient_data = res.user;
      this.next_of_kin = res.next_of_kin_details || {};
      this.isLoaded = true;
    },
  },

  mounted() {
    this.call_api();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex-grow: 1;
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.table-bordered th,
tr,
.table-bordered td {
  border-top: 1px solid #dee2e6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  border-left: 1px solid #dee2e6 !important;
  border-right: 1px solid #dee2e6 !important;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

/* Section Styling */
.section-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-title {
  color: #2c3e50;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #3498db;
}

/* Patient Profile */
.profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.profile-header img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 20px;
  border: 2px solid #ddd;
}

.profile-header h2 {
  margin: 0;
  font-size: 1.5em;
  color: #333;
}

.profile-header p {
  margin: 5px 0 0;
  font-size: 0.9em;
  color: #777;
}

.profile-details {
  margin-top: 20px;
}

.profile-details .detail {
  margin-bottom: 15px;
  width: 100%;
}

.profile-details .detail label {
  display: block;
  font-weight: bold;
  color: #555;
  margin-bottom: 5px;
}

.profile-details .detail span {
  display: block;
  color: #333;
}

/* Next of Kin Styling */
.next-of-kin-section {
  margin-top: 15px;
}

.kin-profile-header {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.kin-avatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-right: 20px;
  border: 2px solid #4caf50;
  object-fit: cover;
}

.kin-profile-header h3 {
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 1.3em;
}

.kin-relationship {
  margin: 0;
  font-size: 0.95em;
  color: #666;
}

.kin-relation-value {
  font-weight: 600;
  color: #e74c3c;
}

/* Kin Details Grid */
.kin-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.kin-detail-item {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #3498db;
}

.kin-detail-item.full-width {
  grid-column: 1 / -1;
}

.kin-detail-item label {
  display: block;
  font-size: 0.85em;
  color: #7f8c8d;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.kin-value {
  display: block;
  font-size: 1em;
  color: #2c3e50;
  font-weight: 500;
}

/* Kin Notes */
.kin-notes {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px dashed #ddd;
}

.kin-notes label {
  display: block;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
}

.kin-notes-content {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #eee;
  color: #555;
  line-height: 1.5;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #95a5a6;
}

.empty-state-icon {
  font-size: 3em;
  margin-bottom: 15px;
  opacity: 0.5;
}

.empty-state p {
  margin: 0;
  font-size: 1.1em;
}

/* Responsive Design */
@media (max-width: 768px) {
  .mmodal-content {
    max-width: 90vw !important;
    margin: 10px;
  }

  .profile-header,
  .kin-profile-header {
    flex-direction: column;
    text-align: center;
  }

  .profile-header img,
  .kin-avatar {
    margin-right: 0;
    margin-bottom: 15px;
  }

  .kin-details-grid {
    grid-template-columns: 1fr;
  }
}

/* Hover effects */
.kin-detail-item:hover {
  background: #f0f7ff;
  transition: background-color 0.3s ease;
}

/* Animation for loading */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
